import { DateTime } from "luxon"

export interface BBInvitations {
    id: string,
    email: string,
    caseIdNumber: string,
    coachId: number,
    programStartDate: Date| null,
    linkExpiryDate: Date| null
    isActive: boolean,
    program:number,
    isCoach:boolean,
    languageId: number
}

export function BBInvitationsDefaultValues(): BBInvitations {
    return {
        id: '', email: '', caseIdNumber: '', coachId: 0, programStartDate: null, linkExpiryDate: null, isActive: true,program:0,isCoach:false, languageId: 1
    }
}

export interface BBInvitationView{
    id:string,
    email: string,
    caseIdNumber:string,
    coach: string,
    branch?: string,
    isBranchVisible?: boolean,
    program: string,
    programStartDate: string,
    inviteExpiryDate: string,
    inviteLink:string,
    dateAccessed:string,
    status:string,
    statusDescription:string,
    isEditEnabled:boolean

}

export function BBInvitationViewDefaultValues():BBInvitationView
{
    return{
        id:'',
        email: '',
        caseIdNumber: '',
        coach: '',
        branch: '',
        isBranchVisible: false,
        program: '',
        programStartDate: '',
        inviteExpiryDate: '',
        inviteLink: '',
        dateAccessed: '',
        status: '',
        statusDescription: '',
        isEditEnabled:false
    }
}

export interface BBSelfGuidedInvite{
    email:string,
    provinceId:number,
    languageId:number
}

export function BBSelfGuidedInviteDefaultValues():BBSelfGuidedInvite{
    return{
        email: '',    
        provinceId: 0,
        languageId: 0
    }
}
